function MonthlyPayment(config, renderer) {
  const self = this;
  Success.call(self, config, renderer);
}